import { render, staticRenderFns } from "./ClinicDentistCard.vue?vue&type=template&id=5f958a92&"
import script from "./ClinicDentistCard.vue?vue&type=script&lang=js&"
export * from "./ClinicDentistCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports